import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../..";

// import { settings } from "./SliderSettings";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";

// import required modules
import { FreeMode } from "swiper";

import SpecialOfferCard from "./SpecialOfferCard";
import { ItemCampaignsPropType } from "../types";
import SpecialOfferPopup from "./SpecialOfferPopup";
import { addToSubCart } from "../../cart/reducer";

const SpecialOffer = () => {
  const home = useSelector((state: IRootState) => state.home.value);
  const dispatch = useDispatch();

  const [isFood, setIsFood] = useState(false);
  const [item, setItem] = useState<ItemCampaignsPropType>({
    id: 0,
    title: "",
    wishlist: null,
    image: "",
    description: "",
    status: false,
    category_id: 0,
    add_ons: [],
    attributes: [],
    choice_options: [],
    category: {
      created_at: "",
      id: 0,
      image: "",
      name: "",
      slug: "",
      status: false,
    },
    establishment: null,
    variations: [],
    price: "",
    tax: "",
    tax_type: "",
    discount: "",
    discount_type: "",
    establishment_id: 0,
    slug: "",
    created_at: "",
    updated_at: "",
    admin_id: 0,
    end_date: "",
    end_time: "",
    start_date: "",
    start_time: "",
  });

  const onClickCard = (item: ItemCampaignsPropType) => {
    setIsFood(true);
    setItem(item);
    dispatch(
      addToSubCart({
        menu_id: item.id,
        menu_quantity: 1,
        menu_name: item.title,
        menu_total: item.price,
        menu_price: item.price,
        menu_image: item.image,
        menu_addons: [],
        menu_variation: [],
        active_vendor: item.establishment?.name,
      })
    );
  };

  return (
    <div>
      {home.home.itemCampaigns.length !== 0 && (
        <div>
          {isFood && (
            <SpecialOfferPopup onClose={() => setIsFood(false)} item={item} restaurant={item} />
          )}
          <div className="container mx-auto p-5 py-7  text-black">
            <div className="font-semibold text-base md:text-lg mb-4">
              Special Food Offers ❤️
            </div>
            <div className="block md:hidden">
              <Swiper
                freeMode={true}
                autoplay={{ delay: 3000 }}
                modules={[FreeMode]}
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                  },
                }}
              >
                {/* <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div> */}
                {home.home.itemCampaigns.map((item, index) => (
                  <SwiperSlide key={index}>
                    <SpecialOfferCard
                      data={item}
                      key={item.id}
                      onClick={() => {
                        onClickCard(item);
                      }}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <div className="hidden md:grid md:grid-cols-3 xl:grid-cols-4 gap-3">
              {home.home.itemCampaigns.map((item) => (
                <SpecialOfferCard
                  data={item}
                  key={item.id}
                  onClick={() => {
                    onClickCard(item);
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpecialOffer;
